import { DsVueCoreError } from "../../DsVueCoreError";
import ImageKit from "imagekit-javascript";

export default class DsImageKitUrl {
  static get(src: string, namedTransformation: string) {
    if (import.meta.env.VITE_APP_IMAGEKIT_URL_ENDPOINT === undefined) {
      throw new DsVueCoreError(
        "VITE_APP_IMAGEKIT_URL_ENDPOINT is missing in .env"
      );
    }

    const urlEndpoint = import.meta.env.VITE_APP_IMAGEKIT_URL_ENDPOINT;

    let imagekit;
    try {
      imagekit = new ImageKit({
        urlEndpoint,
      });
    } catch (e) {
      console.warn(e);
      //If we have not been able to obtain the URL from the ImageKit SDK, use the original URL.
      return src;
    }

    // Destructure path in sections
    const { host, pathname } = new URL(src);
    let directory = "public";

    if (host.includes("private")) {
      directory = "private";
    } else if (host.includes("static")) {
      directory = "static";
    }

    //Get Url from imageKit resize
    return imagekit.url({
      path: pathname,
      urlEndpoint: `${urlEndpoint}/${directory}`,
      transformation: [
        {
          named: namedTransformation,
        },
      ],
    });
  }

  static getTransformationFromNumber(size: number) {
    if (size === 1080) {
      return "xl";
    }
    if (size === 800) {
      return "lg";
    }
    if (size === 500) {
      return "md";
    }
    if (size === 300) {
      return "sm";
    }
    return "xs";
  }
}
